import React, { useState, useEffect } from 'react';
import {
  Button,
  IconButton,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import { useSnackbar } from 'notistack';
import { ACTIONS, MESSAGES } from '../../../shared/constants';
import DataTable from '../../../shared/data-table';
import {
  getAllAreas,
  getSelectedArea,
  saveSelectedArea,
  deleteSelectedArea,
  NewsletterByTypeId
} from '../logic';
import AreaDetails from '../area-detail';
import DeleteIcon from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import AddCircle from '@mui/icons-material/AddCircle';
import ErrorSnackbar from '../../error-snackbar';
import BackDrop from '../../../shared/backdropDE';
import { getUser } from '../../../shared/auth-service';

const AreaReadOnly = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [id, setId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [action, setAction] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(null);
  const user = getUser();
  const companyId = user.countryCode.split('-')[0];

  useEffect(() => {
    async function fetchData() {
      if (loading) {
        try {
          const data = await getAllAreas(companyId);
          setLoading(false);
          setData(data);
        } catch (error) {
          setError(error.message);
          setLoading(false);
          setData([]);
        }
      }
    }
    fetchData();
  });

  useEffect(() => {
    async function fetchRow() {
      if (id) {
        const item = await getSelectedArea(id);
        setSelectedItem(item);
        setId(null);
        setShowModal(true);
      }
    }
    fetchRow();
  });

  const handleSave = async (areaId, identification) => {
    await saveSelectedArea(areaId, identification, companyId);
    setShowModal(false);
    setLoading(true);
    enqueueSnackbar(MESSAGES.SAVED);
  };

  const handleDelete = async (id) => {
      await deleteSelectedArea(id);
      setShowModal(false);
      setLoading(true);
      enqueueSnackbar(MESSAGES.DELETE);
    
  };

  const handleNew = async (action) => {
    setSelectedItem({});
    setId(null);
    setShowModal(true);
    setAction(action)
  };

  const handleActionButton = (e, cellValues, action) => {
    e.stopPropagation();
    setId(cellValues.row.areaId);
    setAction(action);
  };

  const columns = [
    { field: 'areaId', headerName: 'Id', width: 100, flex: 0.2, align: 'center', headerAlign: 'center' },
    { field: 'name', headerName: 'Nombre', width: 250, flex: 0.8, align: 'center', headerAlign: 'center' },
    // {
    //   field: "Editar",
    //   headerName: "Editar",
    //   width: 60,
    //   sortable: false,
    //   renderCell: (cellValues) => {
    //     return <IconButton
    //       color="info"
    //       onClick={(e) => { handleActionButton(e, cellValues, ACTIONS.EDIT) }}
    //     >
    //       <Edit />
    //     </IconButton>;
    //   }
    // },
    // {
    //   field: "Borrar",
    //   headerName: "Borrar",
    //   width: 60,
    //   sortable: false,
    //   renderCell: (cellValues) => {
    //     return <IconButton
    //       aria-label="delete"
    //       color="error"
    //       onClick={(e) => { handleActionButton(e, cellValues, ACTIONS.DELETE) }}
    //     >
    //       <DeleteIcon />
    //     </IconButton>;
    //   }
    // },
  ];

  if (loading) {
    return (
      // <Box sx={{ display: 'flex' }}>
      //     <CircularProgress />
      // </Box>
      <BackDrop />
    );
  }

  if (error) {
    return (<ErrorSnackbar message={error} />);
  }
  const getRowId = (row) => row.areaId;
  return (
    <>
      {showModal && <AreaDetails
        data={selectedItem}
        handleClose={setShowModal}
        action={action}
        handleSave={handleSave}
        handleDelete={handleDelete}
      />}

      <Grid container spacing={2}>
        <Grid item xs={10}>
          <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ flexGrow: 1, m: 1, }}>
           Consultar <span style={{ color: '#00b0ef' }}>Áreas</span>
          </Typography>
        </Grid>
        {/* <Box sx={{ m: 4 }}>
          <Grid item xs={2}>
            <Button
              endIcon={<AddCircle />}
              variant="contained"
              onClick={() => { handleNew(ACTIONS.NEW) }} autoFocus>{ACTIONS.NEW}</Button>
          </Grid>
        </Box> */}
      </Grid>
      <Box display="flex" justifyContent="center">
        <Box width="70%">
            <DataTable 
            columns={columns} 
            rows={data} 
            getRowId={getRowId}
            sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 'bold',
                }
            }}
            />
        </Box>
        </Box>

    </>
  );
};

export default AreaReadOnly;
